import { createContext } from "react";

export interface BaseDialogProps {
  open: boolean;
  onClose: (completed: boolean) => void;
}

export interface DialogOptions {
  persistent: true;
  dialogKey: string;
}

export type DialogComponent<T extends BaseDialogProps> = React.ComponentType<T>;

export interface DialogContextType {
  openDialog: <T extends BaseDialogProps>(
    DialogComponent: DialogComponent<T>,
    props?: Omit<T, keyof BaseDialogProps>,
    options?: DialogOptions
  ) => Promise<boolean>;
}

const DialogContext = createContext<DialogContextType | null>(null);
export default DialogContext;
